import { Data } from "dataclass";
import { UserDto } from "../user.dto";

export class InfluencerViewModel extends Data {
  id: string = "";
  name: string = "";
}

export const mapUserListToInfluencerViewModelList = (users: UserDto[]) => {
  return users.map((user) => {
    return mapUserToInfluencerViewModel(user);
  });
};

export const mapUserToInfluencerViewModel = (
  user: UserDto
): InfluencerViewModel => {
  return InfluencerViewModel.create({
    id: user.id,
    name: user.fullName,
  });
};
